import { Component, OnInit, Input } from '@angular/core';
import { IDNASample } from "../../interfaces/dna-sample";
import { UserService } from '../../services/user.service';
import { IUser } from '../../interfaces/user';
import { Permission } from '../../interfaces/permission.enum';

@Component({
    selector: 'app-sample-display',
    templateUrl: './sample-display.component.html',
    styles: [],
    standalone: false
})
export class SampleDisplayComponent implements OnInit {
  @Input() public dnaSample: IDNASample;

  public showVACORISNumber: boolean = false;
  
  constructor(private readonly userService: UserService) { }

  ngOnInit(): void {
    let currentUser: IUser = this.userService.getCurrentUser();
    this.showVACORISNumber =  currentUser.permissions.includes(Permission.ViewVACORISNumber);
  }

  public renderAliases(aliases: string[]) {
    if (!aliases)
      return "";

    return aliases.join(", ");
  }

  public renderSSNs(ssns: string[]) {
    if (!ssns)
      return "";

    return ssns.join("<br />");
  }
}
